import React from "react";
import serviceimg from "../../src/images/service/imgsm.png";

const About = ({ header }) => {
  return (
    <section
      id="about-us"
      className="flex flex-col gap-3 items-center justify-center pt-8 h-[200px] w-full bg-banner overflow-x-hidden"
    >
      <div className="flex items-center gap-3 justify-center">
        <img
          src={serviceimg}
          alt="Image of a service logo"
          className="w-10 h-5" // Optional: scale image to consistent size
        />
        <h3 className="text-[#F0FFC5] font-semibold text-md">
          {header?.title || "ABOUT US"}
        </h3>
      </div>
      <div className="text-center mx-3 md:mx-0">
        <h2 className="text-[#FFFF] text-3xl font-bold">
          {header?.subtitle || "Empowering Your Drive"}
        </h2>
      </div>
    </section>
  );
};

export default About;
